var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc-container"},[_c('BaseButton',{staticClass:"tc-auto-scroll-button",attrs:{"aria-label":_vm.autoScrollButton.ariaLabel,"text":_vm.autoScrollButton.text},on:{"execute":function($event){_vm.handleScrollToTop()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }